import { Modal } from './presenter';
import { Modal as InstuiModal } from '@instructure/ui-modal';
var ModalHeader = InstuiModal.Header,
  ModalBody = InstuiModal.Body,
  ModalFooter = InstuiModal.Footer;
export { Modal, ModalHeader, ModalBody, ModalFooter };
export default Modal;